<template>
    <div class="new_productAdmin">
         
        <div class="u-max-width  supplierAdminbanner">
               <div style="border-bottom: 1px solid #D1D0D3;">
                    <myNewMenu></myNewMenu>
               </div>
               <div class="supplier-bannnertext">
                  <div class="supplier-bannnertext1">ONEBO一站式出海平台</div>
                  <div class="supplier-bannnertext2">简单做跨境，一产品卖全球</div>
                  <div class="supplier-bannnerbtn u-m-t-60">
                       <div class="bannnerbtn">免费使用</div>
                  </div>
               </div>
               <div class="supplier-bannnerlogo">
                <img style="height:420px" src="../../../assets/images/newImg/product-banner1.png">
               </div>
        </div>
         <div class="u-max-width u-p-t-180 u-p-b-60" style ="background:#FFF">
             <div class="u-min-width productAdminItem2">
                   <div class="productAdminItem2Title u-m-b-50">为什么选择ONEBO ERP</div>
                   <ul class="productAdminItem2-ul u-flex u-row-between">
                        <li>
                            <div class="u-flex-1 u-p-l-40 u-p-r-20">
                                <div class="ul-li-titlt1">API无缝链接</div>
                                <div class="ul-li-titlt2 u-m-t-30">OZON/Shopee/Lazada/Tiktok/shopify等跨境电商平台，实现产品批量刊登上架，无需要二次修改</div>
                                <div class="ul-li-btn u-m-t-30">免费试用</div>
                            </div>
                            <div>
                                <img src="../../../assets/images/newImg/product1.png">
                            </div>
                            
                        </li>
                         <li>
                            <div class="u-flex-1 u-p-l-40 u-p-r-20">
                                <div class="ul-li-titlt1">一站式运营</div>
                                <div class="ul-li-titlt2 u-m-t-30">通过ONEBO ERP实现从智能选品、一键刊登、批量采购到智能化发货多平台多店铺智能运营管理的一站式解决方案</div>
                                <div class="ul-li-btn u-m-t-30">免费试用</div>
                            </div>
                            <div>
                                <img src="../../../assets/images/newImg/product2.png">
                            </div>
                        </li>
                   </ul>
                    <ul class="productAdminItem2-ul u-flex u-row-between u-m-t-20">
                        <li>
                             <div class="u-flex-1 u-p-l-40 u-p-r-20">
                                <div class="ul-li-titlt1">功能多简单</div>
                                <div class="ul-li-titlt2 u-m-t-30">产品管理，订单管理，选品管理，采购管理，权限管理，刊登管理，客户管理，财务管理，分销管理，一个ERP解决所有</div>
                                <div class="ul-li-btn u-m-t-30">免费试用</div>
                            </div>
                            <div>
                                <img src="../../../assets/images/newImg/product3.png">
                            </div>
                        </li>
                         <li>
                             <div class="u-flex-1 u-p-l-40 u-p-r-20">
                                <div class="ul-li-titlt1">无货源运营</div>
                                <div class="ul-li-titlt2 u-m-t-30">海量产品智能选购，0库存风险；一件代发，无资金压力</div>
                                <div class="ul-li-btn u-m-t-30">免费试用</div>
                            </div>
                            <div>
                                <img src="../../../assets/images/newImg/product4.png">
                            </div>
                        </li>
                   </ul>
                  
             </div>
        </div>
         <div class="u-max-width u-p-t-40 u-p-b-20 productAdminItem3">
            <div class="u-min-width">
                <img src="../../../assets/images/newImg/indexImg7.png">
            </div>
         </div>
          <div class="u-max-width u-p-t-40 u-p-b-100" style ="background:#FFF">
             <div class="u-min-width indeAdminItem2">
                   <div class="indeAdminItem2Title u-m-t-180 u-m-b-50">ONEBO能为客户带来什么？</div>
                   <ul class="indeAdminItem2-ul u-flex u-row-between">
                        <li>
                            <div class="ul-li-img"></div>
                            <div class="ul-li-titlt1 u-m-t-30">产品刊登</div>
                            <div class="ul-li-titlt2 u-m-t-30">支持多平台，多店铺，同平台，跨平台，批量采集刊登，无需二次修改，一键批量上架</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-98px 0;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">订单管理</div>
                            <div class="ul-li-titlt2 u-m-t-30">订单实时同步，支持订单批量审核，修改，打单，发货便捷管理</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-195px  0;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">分销平台</div>
                            <div class="ul-li-titlt2 u-m-t-30">海量工厂产品，选品数据分析，一键搬运到各大平台，一件代发，同步物流信息</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-293px  0;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">选品数据管理</div>
                            <div class="ul-li-titlt2 u-m-t-30">产品分析，店铺分析，关键词分析，行业分析，标签词分析</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-391px  0;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">采购管理</div>
                            <div class="ul-li-titlt2 u-m-t-30">批量采购，智能采购管理，采购单跟单管理，智能采购分析</div>
                        </li>
                   </ul>
                    <ul class="indeAdminItem2-ul u-flex u-row-between u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:0 55px;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">数据报表</div>
                            <div class="ul-li-titlt2 u-m-t-30">订单统计，业绩分析，销量统计，利润统计</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-98px 55px;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">批量修改</div>
                            <div class="ul-li-titlt2 u-m-t-30">批量上架，下架，改价格，改重量，改标题，添加水印，图片翻译，图片白底，导入导出</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-195px 55px;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">智能功能</div>
                            <div class="ul-li-titlt2 u-m-t-30">定时上下架，定时发布产品，智能选品，智能刊登，智能采购，智能客户管理</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-293px 55px;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">财务报表</div>
                            <div class="ul-li-titlt2 u-m-t-30">采购明细，订单利润明细，店铺利润明细，每日利润明细，各平台利润明细</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-391px 55px;"></div>
                            <div class="ul-li-titlt1 u-m-t-30">客户管理</div>
                            <div class="ul-li-titlt2 u-m-t-30">户分类，客户分组，批量导出导入客户信息</div>
                        </li>
                   </ul>
             </div>
        </div>
         <div class="u-max-width u-p-t-90 u-p-b-20" style ="background:#F4F5F7">
            <div class="u-p-b-40" style="font-size: 20px;font-family: PingFang SC-Semibold, PingFang SC;font-weight: 600;color: #000000; text-align: center;">管理集成化</div>
            <myContern></myContern>
        </div>
         <div class="u-max-width u-p-t-90 u-p-b-100" style ="background:#FFF">
             <div class="u-min-width productAdminItem4">
                   <div class="productAdminItem4Title">一站式跨境运营</div>
                   <div class="productAdminItem4Title2 u-m-b-50">集成化运营功能</div>
                   <ul class="productAdminItem4-ul u-flex u-row-between">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">数据搬家</div>
                            <div class="ul-li-titlt2 u-m-t-10">10大平台数据互搬互通</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">复制产品</div>
                            <div class="ul-li-titlt2 u-m-t-10">一键复制快速刊登</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">批量编辑</div>
                            <div class="ul-li-titlt2 u-m-t-10">批量修改价格，重量，标题等</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">店铺搬家</div>
                            <div class="ul-li-titlt2 u-m-t-10">A平台一键搬到B平台</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">导入导出</div>
                            <div class="ul-li-titlt2 u-m-t-10">批量产品导入导出</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">定时发布</div>
                            <div class="ul-li-titlt2 u-m-t-10">按计划时间定时发布</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem4-ul u-flex u-row-between u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">一键翻译</div>
                            <div class="ul-li-titlt2 u-m-t-10">中、英，俄文轻松转换</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">营销水印</div>
                            <div class="ul-li-titlt2 u-m-t-10">主图批量添加水印</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">图片白底</div>
                            <div class="ul-li-titlt2 u-m-t-10">主图描述图批量换白底</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">图片翻译</div>
                            <div class="ul-li-titlt2 u-m-t-10">主图描述图中，英，俄文翻译轻松换</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">操作日记</div>
                            <div class="ul-li-titlt2 u-m-t-10">操作过程全面可追溯</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">采集插件</div>
                            <div class="ul-li-titlt2 u-m-t-10">采集分销平台产品数据</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem4-ul u-flex u-row-between u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">批量采购</div>
                            <div class="ul-li-titlt2 u-m-t-10">批量采购出单产品</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">一件代发</div>
                            <div class="ul-li-titlt2 u-m-t-10">分销平台产品全部一件代发</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">打包发货</div>
                            <div class="ul-li-titlt2 u-m-t-10">订单批量打包发货</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">便捷式设备扫码</div>
                            <div class="ul-li-titlt2 u-m-t-10">订单便携式扫码，简单，易操作</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">便捷式设备发货</div>
                            <div class="ul-li-titlt2 u-m-t-10">一键发货，简单易操作</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -159px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">物流追踪</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动追踪物流发货信息</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem4-ul u-flex u-row-between u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">数据报表</div>
                            <div class="ul-li-titlt2 u-m-t-10">精细化看生意运营报表</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">财务分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">精细化看财务各种数据报表</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">采购分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">智能计算采购数量</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">选品分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">多条件搜索产品分析产品</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">客户分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">多条件查看用户信息</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -230px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">采购跟进</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动追踪采购发货信息</div>
                        </li>
                   </ul>
             </div>
        </div>
        <div class="u-max-width u-p-t-60 u-p-b-40 productAdminItem5bg">
             <div class="u-min-width u-p-t-40 u-p-b-20 u-p-b-40 productAdminItem5">
                   <div class="productAdminItem5Title u-m-b-30">智能与自动集成化</div>
                   <ul class="productAdminItem5-ul u-flex u-row-around">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">自动刊登</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动刊登分销平台产品</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">自动评价</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动给买家留评</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">自动上架</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动上架分销平台产品</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">自动审核</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动筛选出特殊订单</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能物流</div>
                            <div class="ul-li-titlt2 u-m-t-10">订单自动物流渠道分配</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -10px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能选品</div>
                            <div class="ul-li-titlt2 u-m-t-10">订单自动物流渠道分配</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem5-ul u-flex u-row-around u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能采购</div>
                            <div class="ul-li-titlt2 u-m-t-10">智能计算采购数量</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能配对</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动与商品建立关系</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -90px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能物流同步</div>
                            <div class="ul-li-titlt2 u-m-t-10">订单物流数据自动同步</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">智能订单统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多平台智能订单统计</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">智能客户统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多平台智能客户统计</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -90px"></div>
                             <div class="ul-li-titlt1 u-m-t-10">智能产品统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多平台产品智能统计</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem5-ul u-flex u-row-around u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能利润统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多平台各种条件利润统计</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能店铺分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">智能分析店铺各种数据</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能关键词分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">智能选择更好用关键词</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能行业分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">更清晰看同行店铺分析</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能标签词分析</div>
                            <div class="ul-li-titlt2 u-m-t-10">智能选择更优的标签词</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-905px -170px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能业绩统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多条件多平台业绩统计</div>
                        </li>
                   </ul>
                     <ul class="productAdminItem5-ul u-flex u-row-around u-m-t-20">
                        <li>
                            <div class="ul-li-img" style="background-position:-60px -245px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能销量统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">多平台多店铺销量统计</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-228px -245px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能利润统计</div>
                            <div class="ul-li-titlt2 u-m-t-10">各平台多条件查询利润</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-397px  -245px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能物流选择</div>
                            <div class="ul-li-titlt2 u-m-t-10">各平台订单智能选择物流</div>
                        </li>
                         <li>
                            <div class="ul-li-img" style="background-position:-568px  -245px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能订单同步</div>
                            <div class="ul-li-titlt2 u-m-t-10">各平台订单自动同步</div>
                        </li>
                         <li>
                            <div class="ul-li-img"  style="background-position:-737px -245px"></div>
                            <div class="ul-li-titlt1 u-m-t-10">智能物流跟踪</div>
                            <div class="ul-li-titlt2 u-m-t-10">自动追踪物流发货信息</div>
                        </li>
                         <li>
                            <div></div>
                           
                        </li>
                   </ul>
             </div>
        </div>
        <div class="u-max-width u-p-t-60 u-p-b-40 productAdminItem6bg">
            <div class="u-min-width productAdminItem6">
                <div class="productAdminItem6Title u-m-t-160 u-m-b-60">ONEBO的服务优势</div>
                <div>
                    <ul class="productAdminItem6-item u-flex u-row-between">
                        <li>
                            <div class="productAdminItem6-text">双向赋能</div>
                            <div class="productAdminItem6-text2">分销平台赋能供应商商品出海，智能化ERP系统一站式赋能卖家简单做跨境</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/1.png">
                            </div>
                        </li>
                         <li>
                            <div class="productAdminItem6-text">一站式服务</div>
                            <div class="productAdminItem6-text2">选品、刊登、采购都在ONEBO，一站式服务无需跨平台操作</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                 <img src="../../../assets/images/newImg/2.png">
                            </div>
                        </li>
                         <li>
                            <div class="productAdminItem6-text">无货源运营</div>
                            <div class="productAdminItem6-text2">ONEBO分销平台优质货源，一件代发，无需囤货，无资金压力</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/3.png">
                            </div>
                        </li>
                        <li>
                            <div class="productAdminItem6-text">高效运营</div>
                            <div class="productAdminItem6-text2">无需团队，一人一ERP，实现多平台多店铺同步高效管理</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/4.png">
                            </div>
                        </li>
                       
                    </ul>
                    <ul class="productAdminItem6-item u-flex u-row-between u-m-t-15">
                        <li>
                            <div class="productAdminItem6-text">批量刊登</div>
                            <div class="productAdminItem6-text2">各平台刊登产品无需二次修改，批量上产品简单快捷</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/5.png">
                            </div>
                        </li>
                         <li>
                            <div class="productAdminItem6-text">批量采购</div>
                            <div class="productAdminItem6-text2">店铺出的订单都可以从ONEBO分销平台一键批量采购</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                 <img src="../../../assets/images/newImg/6.png">
                            </div>
                        </li>
                         <li>
                            <div class="productAdminItem6-text">批量打单更高效</div>
                            <div class="productAdminItem6-text2">ONEBO系统服务器速度快，条码精准，储存时间长，快捷高效</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/7.png">
                            </div>
                        </li>
                        <li>
                            <div class="productAdminItem6-text">全民做跨境</div>
                            <div class="productAdminItem6-text2">一站式服务覆盖跨境电商大中小及小白卖家，赋能全国大中小城市，乃至城镇或者偏远农村做跨境</div>
                            <div class="productAdminItem6-btn">
                                <div>免费试用</div>
                                <img src="../../../assets/images/newImg/8.png">
                            </div>
                        </li>
                       
                    </ul>
                </div>
            </div>
        </div>
        <div class="u-max-width u-p-t-40 u-p-b-20" style ="background:#FFF">
              <div class="u-min-width productAdminItem8">
                <div class="productAdminItem8Title u-m-t-160 u-m-b-60">ONEBO-助你成为跨境大卖家</div>
                <ul class="u-flex u-row-between  productAdminItem8_ul1">
                    <li>
                        <div class="ul-li-img"></div>
                        <div class="ul-li-title1 u-m-t-20">全品类产品线路</div>
                        <div class="ul-li-title2 u-m-t-20">提供产品丰富的跨境分销平台、专业版ERP等产品服务，满足跨境卖家的全产品线路需求</div>
                        <div class="ul-li-title3 u-m-t-20">免费试用<i class="el-icon-arrow-right u-m-l-10"></i></div>
                    </li>
                     <li>
                        <div class="ul-li-img" style="background-position: -180px;"></div>
                        <div class="ul-li-title1 u-m-t-20">覆盖主流平台资源</div>
                        <div class="ul-li-title2 u-m-t-20">无缝对接20+主流跨境电商平台，提供一站式跨境分销服务，覆盖超20W跨境用户</div>
                        <div class="ul-li-title3 u-m-t-20">免费试用<i class="el-icon-arrow-right u-m-l-10"></i></div>
                    </li>
                     <li>
                        <div class="ul-li-img" style="background-position: -355px ;"></div>
                        <div class="ul-li-title1 u-m-t-20">为客户创造便捷</div>
                        <div class="ul-li-title2 u-m-t-20">智能选品、一键刊登、一件采购、一件代发等智能化工具，为跨境卖家跨境运营提供便捷服务</div>
                        <div class="ul-li-title3 u-m-t-20">免费试用<i class="el-icon-arrow-right u-m-l-10"></i></div>
                    </li>
                     <li>
                        <div class="ul-li-img" style="background-position: -532px;"></div>
                        <div class="ul-li-title1 u-m-t-20">为客户创造业绩</div>
                        <div class="ul-li-title2 u-m-t-20">高度专业的研发和运营团队，提供集成化跨境分销解决方案及操作培训，为客户业绩增长保价护航</div>
                        <div class="ul-li-title3 u-m-t-20">免费试用<i class="el-icon-arrow-right u-m-l-10"></i></div>
                    </li>
                     <li>
                        <div class="ul-li-img" style="background-position: -708px ;"></div>
                        <div class="ul-li-title1 u-m-t-20">满足各种跨境业务需求</div>
                        <div class="ul-li-title2 u-m-t-20">支持大中小跨境卖家按需定制，满足各种跨境业务场景</div>
                        <div class="ul-li-title3 u-m-t-20">免费试用<i class="el-icon-arrow-right u-m-l-10"></i></div>
                    </li>
                    
                </ul>
                <div class="productAdminItem8Title u-m-t-160 u-m-b-60">ONEBO-助你成为跨境大卖家</div>
                <ul class="u-flex u-row-between  productAdminItem8_ul2">
                    <li>
                        <div><img  src="../../../assets/images/newImg/ozon.png"></div>
                        <div class="ul-li-title1 u-m-t-20">Ozon</div>
                        <div class="ul-li-title2 u-m-t-20">目前欧洲第四大电商市场，是俄罗斯唯一的多品类综合B2C电商平台。</div>
                        <div class="ul-li-title3 u-m-t-20">
                            <div class="btn btn-1" @click="handleClick('/commertAdmin/Ozon')">入驻通道</div>
                            <div class="btn btn-2">查看详情</div>
                        </div>
                    </li>
                     <li>
                        <div><img src="../../../assets/images/newImg/lazada.png"></div>
                        <div class="ul-li-title1 u-m-t-20">Lazada</div>
                        <div class="ul-li-title2 u-m-t-20">东南亚领先的电商平台，业务覆盖6个东南亚国家</div>
                        <div class="ul-li-title3 u-m-t-20">
                            <div class="btn btn-1" @click="handleClick('/commertAdmin/Lazada')">入驻通道</div>
                            <div class="btn btn-2">查看详情</div>
                        </div>
                    </li>
                     <li>
                        <div><img src="../../../assets/images/newImg/shopee.png"></div>
                        <div class="ul-li-title1 u-m-t-20">Shopee</div>
                        <div class="ul-li-title2 u-m-t-20">增长强劲的东南亚电商平台</div>
                        <div class="ul-li-title3 u-m-t-20">
                            <div class="btn btn-1" @click="handleClick('/commertAdmin/Shopee')">入驻通道</div>
                            <div class="btn btn-2">查看详情</div>
                        </div>
                    </li>
                     <li>
                        <div><img src="../../../assets/images/newImg/shopify.png"></div>
                        <div class="ul-li-title1 u-m-t-20">Shopify</div>
                        <div class="ul-li-title2 u-m-t-20">全球著名的电商类SaaS平台，赋能175个国家的60多万家中小商户</div>
                        <div class="ul-li-title3 u-m-t-20">
                            <div class="btn btn-1" @click="handleClick('/commertAdmin/Shopify')">入驻通道</div>
                            <div class="btn btn-2">查看详情</div>
                        </div>
                    </li>
                </ul>
                <div class="goMoreterrace" @click="handleClick('/serverAdmin1')">查看更多跨境平台 <i class="el-icon-arrow-right u-m-l-10"></i></div>
              </div>
        </div>
        <myNewFoot></myNewFoot>
    </div>
</template>
<script>
import myNewMenu from "@/components/newcomponents/myNewMenu"
import myNewFoot from "@/components/newcomponents/myNewFoot"
import myContern from "@/components/newcomponents/myContern"
export default {
    name:'new_productAdmin',
    data(){
        return {

        }
    },
    components:{
        myNewMenu,
        myNewFoot,
        myContern
    },
    methods:{
          handleClick(url){
            this.$router.push({
                path:url
            })
          }
    }
    
}
</script>
<style lang="scss" scoped>
 .new_productAdmin{
    font-family: PingFang SC-Regular, PingFang SC;

     .supplierAdminbanner{
         background: url("../../../assets/images/newImg/banner_1.png");
         background-size: 100% 100%;
         height: 430px;
         position: relative;
         .supplier-bannnertext{
            width: 500px;
            position: absolute;
            top:110px;
            left: 250px;
            .supplier-bannnertext1{
                font-size: 40px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
            }
            .supplier-bannnertext2{
               margin-top: 40px;
               font-size: 16px;
               font-family: PingFang SC-Regular, PingFang SC;
               font-weight: 400;
            }
            .supplier-bannnerbtn{
                display: flex;
                margin-top: 20px;
                & div{
                    width: 100px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 13px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    cursor: pointer;
                }
                .bannnerbtn{
                    background: linear-gradient(90deg, #FC6B1D 0%, #F98F43 100%);
                    color: #fff;
                }
                .bannnerbtn2{
                    margin-left: 20px;
                    
                    color: #FD681C

                }
            }
         }
         .supplier-bannnerlogo{
            position: absolute;
            bottom:-87px;
            right: 400px;
         }
    }

    .productAdminItem2{
        .productAdminItem2Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
      
        .productAdminItem2-ul{
            li{
                width: 697px;
                height: 240px;
                background: linear-gradient(269deg, #F6F6F6 0%, #ECECEC 100%);
                box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                border-radius: 8px 8px 8px 8px;
                border: 2px solid #FFFFFF;
                display: flex;
                justify-content:space-between;
                align-items: center;
                .ul-li-titlt1{
                    font-size: 21px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #010101;
                }
                .ul-li-titlt2{
                    font-size: 15px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    height: 40px;
                }
                .ul-li-btn{
                    width: 120px;
                    height: 38px;
                    line-height: 38px;
                    text-align: center;
                    border-radius: 2px 2px 2px 2px;
                    opacity: 1;
                    border: 1px solid #FD681C;
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FD681C;
                    cursor: pointer;
                }
            }
        }
    }
    .productAdminItem3{
        background: url('../../../assets/images/newImg/indexImg6.png');
        background-size: 100% 100%;
    }
    .indeAdminItem2{
        .indeAdminItem2Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .indeAdminItem2-ul{
            li{
                width: 205px;
                height: 210px;
                padding:30px 30px 0;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                background: #FFFFFF;
                box-shadow: 0px 0px 18px 1px rgba(51,58,99,0.13);
                border-radius: 4px 4px 4px 4px;
                .ul-li-img{
                    width: 54px;
                    height: 52px;
                    background: url("../../../assets/images/newImg/indexImg2.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 500;
                    color: #000000;
                }
                .ul-li-titlt2{
                    font-size: 13px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    text-align: center;
                }
            }
        }
    }
     .productAdminItem4{
        .productAdminItem4Title{
            font-size: 26px;
            text-align: center;
            font-weight: 600;
            color: #000000;
        }
        .productAdminItem4Title2{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
        }
        .productAdminItem4-ul{
            li{
                width: 125px;
                height: 135px;
                padding:15px 20px 0;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                background: #FFFFFF;
                box-shadow: 0px 3px 15px 1px rgba(0,0,0,0.03), inset 4px 16px 71px 1px rgba(0,0,0,0.03);
                border-radius: 8px 8px 8px 8px;
                opacity: 1;
                border: 2px solid #FFFFFF;
                .ul-li-img{
                    width: 50px;
                    height: 45px;
                    background: url("../../../assets/images/newImg/indexImg3.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    .productAdminItem5bg{
        background: url('../../../assets/images/newImg/indexImg5.png');
        background-size: 100% 100%;
        .productAdminItem5{
            background: #ffffff85;
        .productAdminItem5Title{
           font-size: 20px;
           text-align: center;
           font-family: PingFang SC-Semibold, PingFang SC;
           font-weight: 600;
           color: #000000;
        }
        
        .productAdminItem5-ul{
            li{
                width: 125px;
                height: 135px;
                padding:15px 20px 0;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                flex-direction: column;
                background: #FFFFFF;
                box-shadow: 0px 3px 15px 1px rgba(0,0,0,0.03), inset 4px 16px 71px 1px rgba(0,0,0,0.03);
                border-radius: 8px 8px 8px 8px;
                opacity: 1 !important;
                border: 2px solid #FFFFFF;
                .ul-li-img{
                    width: 50px;
                    height: 45px;
                    background: url("../../../assets/images/newImg/indexImg4.png");
                }
                .ul-li-titlt1{
                    font-size: 16px;
                    font-weight: 400;
                    color: #37312D;
                }
                .ul-li-titlt2{
                    font-size: 14px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #888888;
                    text-align: center;
                }
            }
        }
    }
    }
     .productAdminItem6bg{
        background:#FFF;
        .productAdminItem6{
             .productAdminItem6Title{
                font-size: 20px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
                text-align: center;
             }
             .productAdminItem6-item{
                li{
                    width: 297px;
                    height: 278px;
                    padding: 30px 20px 0 20px;
                    background: linear-gradient(312deg, #FAFEFF 0%, #F2F3F7 100%);
                    box-shadow: 0px 3px 21px 1px rgba(56,89,197,0.03);
                    border-radius: 8px 8px 8px 8px;
                    opacity: 1;
                    border: 2px solid #FFFFFF;
                    .productAdminItem6-text{
                        font-size: 18px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                    }
                    .productAdminItem6-text2{
                        font-size: 15px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        padding-right:60px;
                        margin-top: 20px;
                    }
                    .productAdminItem6-btn{
                        display: flex;
                        justify-content: space-between;
                        & div{
                            width: 100px;
                            height: 30px;
                            line-height: 30px;
                            text-align: center;
                            margin-top: 50px;
                            border-radius: 2px 2px 2px 2px;
                            opacity: 1;
                            border: 1px solid #FD681C;
                            font-size: 14px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FD681C;
                            cursor: pointer;
                        }
                        & img{
                            width: 170px;
                        }
                    }
                }
                
             }
        }
    }
    
    .productAdminItem8{
        .productAdminItem8Title{
            font-size: 20px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            text-align: center;
        }
        .productAdminItem8_ul1{
            li{
               flex: 1;
               display: flex;
               justify-content: center;
               align-items: center;
               flex-direction: column;
               margin-right: 70px;
               &:last-child{
                 margin-right: 0px;
               }
               .ul-li-img{
                  width: 120px;
                  height: 108px;
                  background: url("../../../assets/images/newImg/indexImg1.png");
                 
               }
               .ul-li-title1{
                  font-size: 16px;
                  font-weight: 400;
                  color: #000000;
               }
               .ul-li-title2{
                  font-size: 14px;
                  font-weight: 400;
                  color: #999999;
                  height: 55px;
               }
               .ul-li-title3{
                 font-size: 16px;
                 font-weight: 400;
                 color: #FD681C;
                 cursor: pointer;
               }
            }
        }
        .productAdminItem8_ul2{
             li{
                width: 210px;
                background: url("../../../assets/images/newImg/indexImg9.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                justify-content: center;
                align-items:flex-start;
                flex-direction: column;
                padding: 30px 60px 60px;
                & img{
                    height: 30px ;
                }
                .ul-li-title1{
                    font-size: 22px;
                    font-weight: 400;
                    color: #000000;
                }
                .ul-li-title2{
                    height: 55px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #555555;
                }
                 .ul-li-title3{
                    font-size: 14px;
                    font-weight: 400;
                    display: flex;
                    .btn{
                        width: 102px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border-radius: 2px 2px 2px 2px;
                        opacity: 1;
                        cursor: pointer;
                    }
                    .btn-1{
                         color:#FD681C;
                         border: 1px solid #FD681C;
                    }
                    .btn-2{
                        margin-left: 12px;
                        color: #C9CDD4;
                         border: 1px solid #C9CDD4;
                    }
                }
             }
        }
        .goMoreterrace{
            width: 192px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            margin: 30px auto 20px;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #FD681C;
            font-size: 14px;
            font-weight: 400;
            color: #FD681C;
            cursor: pointer;
        }
    }
    
 }
</style>